// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  message: '',
};

const actions = {
  getVenues:
    (token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch(
            '/api/bread/jwt/user_x_garage_workshops/static/search_venues',
            options
          );
          const res = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ listVenues: res.venues });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  getUsers:
    (token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch(
            '/api/bread/jwt/user_x_garage_workshops/static/list',
            options
          );
          const res = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ listUsers: res.listUsers });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  getUserId:
    (token, id) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch(
            `/api/bread/jwt/user_x_companies/static/edit?id=${id}`,
            options
          );
          const res = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ userCompany: res.driver });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  update:
    (data, token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch('/api/bread/jwt/user_x_companies/static/update', options);
          const garageWorkShopResponse = await response.json();

          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ status: garageWorkShopResponse.status });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  add:
    (data, token, locale) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch(
            `/api/bread/jwt/user_x_garage_workshops/static/add_user_venues?lang=${locale}`,
            options
          );
          const garageWorkShopResponse = await response.json();

          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ status: garageWorkShopResponse.status });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
};

const Store = createStore({
  initialState,
  actions,
  name: 'userWorkShopRegister',
});

export default createHook(Store);
